export { default } from './ShouldAccess'
